import './DefaultSubSlider.less';

import React from 'react';
import clsx from 'clsx';

function DefaultSubSlider({ className, children }) {
    return <div className={clsx('default-sub-slider', className)}>{children}</div>;
}

export default DefaultSubSlider;
